import { intervalToDuration, isValid } from 'date-fns';

export default function Age(date) {
  const targetDate = new Date(date);
  const currentDate = new Date();

  if (!isValid(targetDate)) {
    return 'Invalid date';
  }

  const { years, months, days } = intervalToDuration({
    start: targetDate,
    end: currentDate,
  });

  const decimalAge = years + months / 12 + days / 365;
  return decimalAge;
};



// WEBPACK FOOTER //
// ./src/components/Helpers/Dates/Age.js